import { render } from "./BannerUploaderItem.vue?vue&type=template&id=768edf6c&scoped=true"
import script from "./BannerUploaderItem.vue?vue&type=script&lang=js"
export * from "./BannerUploaderItem.vue?vue&type=script&lang=js"

import "./BannerUploaderItem.vue?vue&type=style&index=0&id=768edf6c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768edf6c"]])

export default __exports__